import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';

const Pencil = (props) => (
  <SvgIcon {...props} viewBox="0 0 60 60">
    <polygon fill="none" stroke={props.color} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="
	57,17.749 19.931,54.818 9,57 11.182,46.069 48.251,9 "/>
    <line fill="none" stroke={props.color} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" x1="40.636" y1="16.636" x2="49.393" y2="25.356"/>
    <line fill="none" stroke={props.color} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" x1="11.182" y1="46.091" x2="19.909" y2="54.818"/>
    <line fill="none" stroke={props.color} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" x1="30.818" y1="27.545" x2="33" y2="29.727"/>
    <line fill="none" stroke={props.color} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" x1="35.182" y1="23.182" x2="39.022" y2="27"/>
  </SvgIcon>
);

export default Pencil;


// WEBPACK FOOTER //
// ./src/icons/Pencil.jsx